﻿var accordion = {};

accordion = {

  init: function () {
    var me = this;
    var accordions = document.getElementsByClassName('accordion');

    Array.prototype.forEach.call(accordions, function (accordion, index) {
      me.bind(accordion);
    });

  },

  bind: function (container) {

    var tabs = container.getElementsByClassName('accordion__tab');

    Array.prototype.forEach.call(tabs, function (tab, index) {
      
      tab.addEventListener('click', function (e) {

        e.preventDefault();

        var parent = tab.parentNode;

        parent.classList.toggle('accordion__item--is-open');


      });

    });

  }
};

accordion.initialize = function () {
  accordion.init();
};

module.exports = accordion;
